import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as InvoiceActions from './invoice.actions';
import { InvoiceEntity } from './invoice.models';

export const INVOICE_FEATURE_KEY = 'invoice';

export interface State extends EntityState<InvoiceEntity> {
  selectedId?: string | number; // which Invoice record has been selected
  loading: boolean; // has the Invoice list been loading
  error?: string | null; // last none error (if any)
  endingBefore: string;
  startingAfter: string;
}

export interface InvoicePartialState {
  readonly [INVOICE_FEATURE_KEY]: State;
}

export const invoiceAdapter: EntityAdapter<InvoiceEntity> = createEntityAdapter<
  InvoiceEntity
>();

export const initialState: State = invoiceAdapter.getInitialState({
  // set initial required properties
  loading: false,
  endingBefore: null,
  startingAfter: null
});

const invoiceReducer = createReducer(
  initialState,
  on(InvoiceActions.resetInvoices, state =>
    invoiceAdapter.removeAll({
      ...state,
      error: null,
      endingBefore: null,
      startingAfter: null
    })
  ),
  // on(InvoiceActions.loadInvoice, state => ({
  //   ...state,
  //   loading: true,
  //   error: null
  // })),

  on(InvoiceActions.loadInvoiceFromEmail, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(InvoiceActions.loadInvoiceSuccess, (state, { invoice, loadType }) => {
    const currentInvoices = Object.keys(state.entities).map(
      key => state.entities[key]
    );

    let { endingBefore, startingAfter } = state;

    const newInvoices =
      loadType === 'newer'
        ? [...invoice, ...currentInvoices]
        : [...currentInvoices, ...invoice];

    if (newInvoices.length > 0) {
      endingBefore = newInvoices[0].id;
      startingAfter = newInvoices[newInvoices.length - 1].id;
    }

    return invoiceAdapter.setAll(newInvoices, {
      ...state,
      loading: false,
      startingAfter,
      endingBefore
    });
  }),
  on(InvoiceActions.loadInvoiceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return invoiceReducer(state, action);
}
